module.exports = __webpack_public_path__ + "img/cpzxIcon5.444b877b.png";